/**
 * Created by qingzhui on 16/12/31.
 */

require('../../scss/m/m-irmanage.scss');

var common = require('./m-common');

var $ = require('jquery');


$(function () {

    $(window).scroll(function () {
        //检测滚走的高度
        var scrollT = $(document).scrollTop();
        //当滚走的高度>=400(天蓝色色块的上边距)，
        //显示返回顶部(.back)，否则隐藏返回顶部
        //获取蓝色色块(container)距离文档顶部的距离
        var offsetT = $("body").offset().top;
        //进行判断
        if (scrollT >offsetT) {
            $(".scoll").show()
        } else {
            $(".scoll").hide()
        }
    })
    
    //点击返回顶部，页面滚走的距离设置为0
    $(".scoll").click(function(){
        //生硬的返回
        // $(document).scrollTop(0)
        //动感的返回
        //animate({键:值},时间) 属性：scrollTop---必须是被元素调用
        $("html,body").animate({
            scrollTop:0
        },1000)
    })
    // 查看更多
    var isClick = false;

    var con1 = $('.m-business .btn-more').prev().html();

    var langInput = document.getElementById('lang');
    var lang = langInput ? langInput.value : undefined;

    var baseUrl = common.baseUrl();
    var $memberList = $('.m-leadership #list');
    // 请求的所有地址
    var ajaxUrl = {
        memberList: baseUrl + '/v1/ir/manage?lang=' + lang
    };
    $.ajax({
        url: ajaxUrl.memberList,
        type: 'get',
        dataType: 'json',
        data: {},
        success: function (data) {
            if (data.status) {
                var {result}=data
                $('#ir').addClass('active');
                $('.show').append(getcon(result.distribution))
                $('.theHedOfText').html(result.theHedOfText)
                
                $('#header').html(settabHeader(result.theCommittee))
                $('.tbody').html(settabTbody(result.manage,result.theCommittee))
                $('.description .text').html(result.starTargetInfo)
                for (let i = 0; i < result.distribution.length; i++) {
                    $(`.show${i} .accordions-head`).click(function(){
                    if($(`.show${i} .showHidden`).hasClass('active')){
                        $(`.show${i} .showHidden`).removeClass('active')
                        $(`.jia${i}`).removeClass('act')
                        $(`.show${i} .showHidden`).slideUp()
                    }else{
                        $(`.show .showHidden`).removeClass('active')
                        $(`.show .showHidden`).slideUp()
                        for (let i = 0; i < result.distribution.length; i++) {
                            $(`.jia${i}`).removeClass('act')
                        }
                        $(`.show${i} .showHidden`).addClass('active')
                        $(`.jia${i}`).addClass('act')
                        $(`.show${i} .showHidden`).slideDown()

                    }
                    })
    }
            } else {
                // 错误，打印返回的数据分析情况
                console.log(data);
            }
        }
    });
    function settabHeader(arr){
        let html='<th style="width: 64.6094px; height: 25px;" scope="col">&nbsp;</th>'
        for(let i=0;i<arr.length;i++){
            html+=`<th style="width: 64.2188px; height: 25px;" scope="col">${arr[i].name}</th>` 
        }
        return html
    }
    function settabTbody(arr,header){
        let html=''
        for(let i=0;i<arr.length;i++){
            html+=`<tr style="height: 52px;">${settabTbodycontent(arr[i],header)}</tr>` 
        }
        return html
    }
    function settabTbodycontent(arr,header){
        let html=''
        for(var key in arr){
            if(key==='name'){
                html+=`<th style="width: 64.6094px; height: 52px;" scope="row">${arr[key]}${arr.starTarget==='1'?'<span>*</span>':''}</th>`
            }else if(key ==='takeOfficeList'){
                for(let i=0;i<header.length;i++){
                    if(arr[key].some(it=>it.committeeId==header[i].id)){
                        let find=arr[key].find(it=>it.committeeId==header[i].id)
                    let text=''
                    if(lang==='zh'){
                        text=find.chsJobName
                    }else if(lang==='trzh'){
                        text=find.tcJobName
                    }else if(lang==='en'){
                        text=find.enJobName
                    }
                    html+=`<td style="width: 64.2188px; height: 52px;">${find.showType==2?'<span style="font-size: 40pt;vertical-align: middle;">•</span>':(text?text:'')}</td>`
                }else{
                    html+=`<th style="width: 64.6094px; height: 25px;" scope="col">&nbsp;</th>`
                }
                }
             }
        }
        return html
    }
    function setmap(arr){
        let a=''
        let text=''
        if(lang==='zh'){
            text='主席'
        }else if(lang==='trzh'){
            text='主席'
        }else if(lang==='en'){
            text='chairman'
        }
        if(arr&&arr.length>0){
            for (let i = 0; i < arr.length; i++) {
                a+=`<div class='according-content'>
                        <div class='col-md-7'>
                        <h2>${arr[i].name}${arr[i].isChairman==='1'?`(${text})`:''}<br>${arr[i].position}</h2>
                        <div class='${arr[i].personalProfile.length!==1?'clearfloat':''}'>
                        <p>
                        ${
                            arr[i].personalProfile?arr[i].personalProfile.replace(/\n/g,"<p style='padding:2px 0;'></p>"):''
                        }
                        </p>
                        </div>
                        </div>
                        
                    </div>`
            }          
        }
        
        return a
    }
    function getcon(arr){
        let b=''
        for (let i = 0; i < arr.length; i++) {
                b+=`<div class='show${i}'>
                        <div class='title accordions-head'><span class='jia${i}'></span> <div class='accordions-head-title'>${arr[i].title}</div></div>
                        <div class='showHidden accordion-content'>
                        <div class='flotHeader'>${arr[i].description?arr[i].description:''}</div>

                        ${
                            setmap(arr[i].list)
                        }
                        </div>
                    </div>`
            }
            return b
    }
    
});


// WEBPACK FOOTER //
// ./src/m/m-irmanage.js